import { create } from 'zustand'

const EMPTY_LIST = []

/**
 * 下级 App 别名（GET /product-packages 全量），按 pid 分组。
 * - lists：启用项 [{ code, name, sort }]，按 sort 排序，供下拉使用
 * - names：全部项 code → alias（含停用），供展示历史数据时查别名
 */
export const useProductPackagesStore = create((set) => ({
  loaded: false,
  lists: {},
  names: {},
  setItems: (items = []) => {
    const lists = {}
    const names = {}
    const sorted = [...items].sort(
      (a, b) => (a.sort ?? 0) - (b.sort ?? 0),
    )
    sorted.forEach(({ pid, code, alias, sort, enabled }) => {
      const key = String(pid)
      names[key] = { ...names[key], [code]: alias }
      if (enabled === undefined || Number(enabled) === 1 || enabled === true) {
        lists[key] = [...(lists[key] ?? []), { code, name: alias, sort }]
      }
    })
    set({ loaded: true, lists, names })
  },
}))

/** pid 14 与 JP 游戏分组 total3 共用 pid 14 的子包列表 */
export const toPackagePid = (pid) => {
  const value = String(pid)
  if (value === '14' || value === 'total3') return '14'
  if (value === '36') return '36'
  return null
}

export const selectProductPackages = (state, pid) => {
  const key = toPackagePid(pid)
  return (key && state.lists[key]) || EMPTY_LIST
}

/** 跨 pid 查别名：先 14 再 36，找不到返回 code */
export const selectPackageName = (state, code) => {
  if (!code) return code
  return state.names['14']?.[code] ?? state.names['36']?.[code] ?? code
}
